import { productionService } from "@/services/productionService";
import { previewService } from "@/services/previewService";
import type { Service } from "@/types/Service";
import { IS_PRODUCTION } from "@/config";

const searchParams = new URLSearchParams(window.location.search);
const hasPreviewParam = searchParams.get("mode") === "preview";

export const IS_PREVIEW =
  (hasPreviewParam && !IS_PRODUCTION) || window.__FORM_MODE__ === "preview";

// Skip loading the active payment gateway's client SDK in preview mode only — no
// real payment is taken there. Static-config builds DO process real payments (#871),
// so the gateway must still load there. Gateway-agnostic: any driver honours it.
export const SKIP_PAYMENT_GATEWAY = IS_PREVIEW;

export function getService(): Service {
  return IS_PREVIEW ? previewService : productionService;
}
